import Restaurant from "@material-symbols/svg-500/rounded/restaurant.svg?react";
import { memo } from "react";

import { IconCreator } from "./_utils/icon-creator";

import type { SVGIconProps } from "./_utils/icon-creator";

const RestaurantIcon = (props: SVGIconProps) => {
	const Icon = () => IconCreator({ ...props, svgIcon: Restaurant });
	return <Icon />;
};

export default memo(RestaurantIcon);
